import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from 'ng2-bootstrap-modal';
import { saveAs } from 'file-saver';
import { ConfirmComponent } from '../../../../shared/confirm/confirm.component';

@Component({
  selector: 'app-bc-ap-attachment',
  templateUrl: './bc-ap-attachment.component.html',
  styleUrls: ['./bc-ap-attachment.component.scss']
})
export class BcApAttachmentComponent implements OnInit {



  @Input("proposalID") proposalID;
  @Input("clientID") clientID;
  @Input("isView") isView;

  private proposalAttachments;
  private proposalType = 1; // 0 = Proposta Prorrogação, 1 = Proposta Abono, 2 = Proposta Juridico
  private description = '';


  constructor(  private bcAccountClientService: BcAccountClientService,
                private flashMessagesService: FlashMessagesService,
                private dialogService: DialogService) { }



  ngOnInit() {
    this.getProposalAttachments();
  }

  getProposalAttachments() {
		this.bcAccountClientService.getAttachmentsList(this.proposalID, this.proposalType).subscribe(result => {
			if (result.Success) {
        this.proposalAttachments = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
  }
  
  
  fileSelected() {
    var input: any = document.getElementById("apFileAttach");
    var file = input.files[0];
    this.uploadAttachment(file, this.description);
    input.value = null;
    this.description = '';
}


uploadAttachment(file, description) {

this.bcAccountClientService.insertProposalAttachment(this.clientID, this.proposalID, this.proposalType, description, file).subscribe(result => {
  if (result.Success) {
    this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });				
    this.getProposalAttachments();
  } else {
    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
  }
}, error => {
    console.log(error);
  });
}

downloadAttachment(index) {
  this.bcAccountClientService.downloadAttachment(this.proposalAttachments[index].ID).subscribe(blob => {
      if (blob) {
          saveAs(blob, this.proposalAttachments[index].NomeArquivo);
      } else {
          this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
      }
  }, error => {
      console.log(error);
  });
}


inactivateAttachment(id) {

this.bcAccountClientService.inactivateAttachment(id).subscribe(result => {
  if (result.Success) {
    this.flashMessagesService.show("Anexo removido com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
    this.getProposalAttachments();
  } else {
    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
  }
}, error => {
  console.log(error);
});
}

showRemoveAttachModal(id) {
let disposable = this.dialogService.addDialog(ConfirmComponent, {
  title: 'Confirmação',
  message: 'Confirma a exclusão do anexo?',
  warning: "Essa ação não poderá ser revertida."
},
  { backdropColor: 'rgba(0, 0, 0, 0.5)' })
  .subscribe((isConfirmed) => {
    //We get dialog result
    if (isConfirmed) {
      this.inactivateAttachment(id);
    }
    else {
      //Do nothing here for now
    }
  });
}



}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-attachment/bc-ap-attachment.component.ts